import { Switchboard } from "../../lib/events";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class CancelSelectButton extends ToolbarButton {
    constructor(p_layer, b_layer) {
        super('times', 'Exit Result Set View', 'cancelSelectButton');
        this.p_layer = p_layer;
        this.b_layer = b_layer;
        this.emitter = Switchboard.get_emitter("CONTEXT");
    }
    _action() {
        this.b_layer.clear();
        this.p_layer.remove_features_except(this.p_layer.clicked);
        this.emitter.emit('ctx_request', 'singleton');
        this.ui.removeClass('highlighted');
        $(document).trigger('group_interaction_cancelled');
    }
}
